import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import React from 'react';
// This matches the processing that happens in fetch-templates.ts for hooking
// the feedback component up to the "Feedback" link in the default header.
var DEFAULT_CONTACT_FORM_ID = 'contactForm';
/**
 * Adds the <cob-contact-form> web component to the page.
 *
 * Follow the instructions in the cob-contact README for generating the token
 * prop.
 */

var ContactForm =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ContactForm, _React$Component);

  function ContactForm() {
    _classCallCheck(this, ContactForm);

    return _possibleConstructorReturn(this, _getPrototypeOf(ContactForm).apply(this, arguments));
  }

  _createClass(ContactForm, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          defaultSubject = _this$props.defaultSubject,
          to = _this$props.to,
          token = _this$props.token,
          action = _this$props.action;
      return React.createElement("cob-contact-form", {
        id: id || DEFAULT_CONTACT_FORM_ID,
        "default-subject": defaultSubject,
        to: to,
        token: token || '',
        action: action
      });
    }
  }], [{
    key: "makeMailtoClickHandler",
    value: function makeMailtoClickHandler(contactFormId) {
      return function (ev) {
        var contactFormEl = document.getElementById(contactFormId);

        if (contactFormEl) {
          contactFormEl.show();
          ev.preventDefault();
        }
      };
    }
  }]);

  return ContactForm;
}(React.Component);

export { ContactForm as default };